import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  TASK_DETAIL: 'task-task-detail'
}

const routes = [
  {
    path: 'task/:id/',
    name: ROUTES.TASK_DETAIL,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['tasks_task_list'],
      requiresAuth: true
    },
    component: () => import('./TaskDetailPage.vue')
  }
]

export { routes, ROUTES }
